"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Avatar = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));

var _styles = require("@material-ui/core/styles");

var _AccountCircle = _interopRequireDefault(require("@material-ui/icons/AccountCircle"));

var _classnames = _interopRequireDefault(require("classnames"));

var _md = _interopRequireDefault(require("md5"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _cacheProvider = require("../Utilities/cache/cacheProvider");

var _styles2 = require("./styles.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Avatar = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Avatar, _Component);

  var _super = _createSuper(Avatar);

  function Avatar() {
    var _this;

    (0, _classCallCheck2.default)(this, Avatar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      src: _this.props.src
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "createInitials", function (name) {
      var nameParts = name.split(" ");
      var initials = ""; // Max out at 3 characters

      var numInitials = Math.min(nameParts.length, 3);

      for (var i = 0; i < numInitials; i++) {
        initials += nameParts[i].charAt(0);
      }

      return initials;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getGravatar", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this$props, email, src, emailMd5, cache, cacheKey, cachedImage, request;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, email = _this$props.email, src = _this$props.src;

              if (!(email && src === undefined)) {
                _context.next = 13;
                break;
              }

              emailMd5 = (0, _md.default)(email.trim().toLowerCase());
              cache = _cacheProvider.CacheProvider.getInstance();
              cacheKey = "gravatar:".concat(email);
              cachedImage = cache.get(cacheKey);

              if (!(cachedImage !== undefined)) {
                _context.next = 9;
                break;
              }

              _this.setState({
                src: cachedImage
              });

              return _context.abrupt("return");

            case 9:
              request = new XMLHttpRequest();

              request.onload = function () {
                if (request.status === 200) {
                  cache.set(cacheKey, "https://www.gravatar.com/avatar/".concat(emailMd5, ".png?d=404"));

                  _this.setState({
                    src: "https://www.gravatar.com/avatar/".concat(emailMd5, ".png?d=404")
                  });
                } else {
                  cache.set(cacheKey, null);
                }
              };

              request.open("GET", "https://www.gravatar.com/avatar/".concat(emailMd5, ".png?d=404"));
              request.send();

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", function () {
      _this.getGravatar();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidUpdate", function (prevProps) {
      if (_this.props.src && _this.props.src !== _this.state.src) {
        _this.setState({
          src: prevProps.src
        });
      } else if (prevProps.email !== _this.props.email) {
        _this.getGravatar();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getPropsForComponent", function () {
      var _this$props2 = _this.props,
          classes = _this$props2.classes,
          src = _this$props2.src,
          email = _this$props2.email,
          name = _this$props2.name,
          gutter = _this$props2.gutter,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props2, ["classes", "src", "email", "name", "gutter"]);
      return otherProps;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props3 = _this.props,
          alt = _this$props3.alt,
          className = _this$props3.className,
          classes = _this$props3.classes,
          children = _this$props3.children,
          gutter = _this$props3.gutter,
          srcSet = _this$props3.srcSet,
          size = _this$props3.size,
          name = _this$props3.name;
      var src = _this.state.src;
      var renderedChildren;
      var hasChildren = true;

      if (children) {
        renderedChildren = children;
      } else {
        if (name) {
          renderedChildren = _this.createInitials(name);
        } else {
          renderedChildren = /*#__PURE__*/_react.default.createElement(_AccountCircle.default, {
            className: (0, _classnames.default)("prmbl-avatar-default", classes["gutter" + gutter], classes["default" + size])
          });
          hasChildren = false;
        }
      }

      var renderedAlt;

      if (alt) {
        renderedAlt = alt;
      } else {
        if (name) {
          renderedAlt = name;
        }
      }

      var propsToUse = _this.getPropsForComponent();

      return /*#__PURE__*/_react.default.createElement(_Avatar.default, (0, _extends2.default)({}, propsToUse, {
        className: (0, _classnames.default)("prmbl-avatar", className, classes.root, src || srcSet ? classes.withImage : classes.withoutImage, hasChildren ? classes.withChildren : classes.withoutChildren, classes["gutter" + gutter], classes[size]),
        alt: renderedAlt,
        src: src
      }), renderedChildren);
    });
    return _this;
  }

  return Avatar;
}(_react.Component);

exports.Avatar = Avatar;
(0, _defineProperty2.default)(Avatar, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string,

  /**
   * Used in combination with `src` or `srcSet` to provide an alt attribute for the rendered `img` element.
   */
  alt: _propTypes.default.string,

  /**
   * Used to render icon or text elements inside the Avatar. When children are provided, the `name`, `src` and `alt` props will not be used and no `img` will be rendered by default. This can be an element, or just a string.
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   *
   * For styling up the component without exposing this in styleguidist.
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The left/right margin around the avatar.
   */
  gutter: _propTypes.default.oneOf(["left", "right", "both", "none"]),

  /**
   * The name of the user. This is used to generate the initials shown. If children are provided this will not be shown. If no `alt` provided, this will be used instead.
   */
  name: _propTypes.default.string,

  /**
   * Event handler for onBlur
   */
  onBlur: _propTypes.default.func,

  /**
   * Event handler for onFocus
   */
  onFocus: _propTypes.default.func,

  /**
   * Event handler for onMouseLeave
   */
  onMouseLeave: _propTypes.default.func,

  /**
   * Event handler for onMouseOver
   */
  onMouseOver: _propTypes.default.func,

  /**
   * Event handler for onTouchEnd
   */
  onTouchEnd: _propTypes.default.func,

  /**
   * Event handler for onTouchStart
   */
  onTouchStart: _propTypes.default.func,

  /**
   * The size of the avatar.
   */
  size: _propTypes.default.oneOf(["small", "medium", "large"]),

  /**
   * The `sizes` attribute for the `img` element.
   */
  sizes: _propTypes.default.string,

  /**
   * The `src` attribute for the `img` element.
   */
  src: _propTypes.default.string,

  /**
   * The `srcSet` attribute for the `img` element.
   */
  srcSet: _propTypes.default.string,

  /**
   * The user's email. Used to fall back to Gravatar
   */
  email: _propTypes.default.string
});
(0, _defineProperty2.default)(Avatar, "defaultProps", {
  className: "",
  gutter: "none",
  size: "small"
});

var _default = (0, _styles.withStyles)(_styles2.styles)(Avatar);

exports.default = _default;